import {EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormArray, FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

export class SubformArray implements OnInit, OnDestroy {
    @Input() fbArray: FormArray = new FormArray([]);

    @Output() validStatusChange = new EventEmitter<boolean>();

    subs: Subscription[] = [];

    addGroup() {
        this.fbArray.push(new FormGroup({}));
    }

    ngOnInit() {
        this.subs.push(
            this.fbArray.statusChanges.pipe(
                debounceTime(100),
                distinctUntilChanged(),
            ).subscribe((status: string) => {
                this.validStatusChange.emit(status.toUpperCase() !== 'INVALID');
            })
        );
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}
